import { teamsQuery, useDeleteTeamMutation } from "@common/api/teams"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/teams/_list/$teamId/delete",
)({
  component: DeleteTeamDialog,
})

function DeleteTeamDialog(): React.ReactElement | null {
  const { teamId } = Route.useParams()
  const { data } = useSuspenseQuery(teamsQuery())
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const deleteMutation = useDeleteTeamMutation()
  const team = data.data.find((item) => item.id === teamId)

  if (!team) {
    return null
  }

  const close = () =>
    navigate({
      to: "/settings/workspace/teams/$teamId",
      params: { teamId },
      search: true,
    })

  const confirm = () =>
    deleteMutation.mutate(
      { team_id: teamId },
      {
        onSuccess: () => {
          showToast("Archived", `${team.name} archived.`, "success")
          navigate({ to: "/settings/workspace/teams", search: true })
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Archive ${team.name}?`}
      description="This hides the team from active lists. You can restore it from the Archived tab."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={deleteMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
